export default __webpack_public_path__ + "static/media/tete95.3723e66e.png";